import { AlertCircle, CheckCircle2, Info, XCircle, X } from "lucide-react";

const VARIANTS = {
  error:   { wrap: "bg-rose-50 border-rose-200 text-rose-700",       Icon: XCircle },
  warning: { wrap: "bg-amber-50 border-amber-200 text-amber-800",    Icon: AlertCircle },
  info:    { wrap: "bg-blue-50 border-blue-200 text-blue-700",       Icon: Info },
  success: { wrap: "bg-emerald-50 border-emerald-200 text-emerald-700", Icon: CheckCircle2 },
};

/**
 * Banner — unified info/warning/error/success banner used across the app.
 *
 *   <Banner variant="error">{errorMessage}</Banner>
 *   <Banner variant="info" onClose={() => setMsg("")}>{msg}</Banner>
 */
export default function Banner({ variant = "info", children, onClose, testid = "banner", className = "" }) {
  if (!children) return null;
  const { wrap, Icon } = VARIANTS[variant] || VARIANTS.info;
  return (
    <div className={`flex items-start gap-2 border rounded p-3 text-sm ${wrap} ${className}`} data-testid={testid}>
      <Icon className="h-4 w-4 mt-0.5 shrink-0" />
      <div className="flex-1">{children}</div>
      {onClose && (
        <button type="button" onClick={onClose} className="p-1 hover:bg-black/5 rounded" data-testid={`${testid}-close`}>
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
